/*
 * File: d:\projects\AutoFiFront\src\Content\Modals\ModalConfirmation\ModalConfirmation.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday April 24th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday April 24th 2023 4:28:57 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { MouseEventHandler } from 'react';
import MyModal from "Content/Modals/MyModal";
import { useNavigate } from 'react-router-dom';
import RouterPathResolver from "Config/Router/RouterPathResolver";
import translator from 'MultiLanguage/TranslationWrapper';
import styles from "Content/Modals/ModalConfirmation/ModalConfirmation.module.css";

type ModalConfirmationProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string,
    isOkay: boolean
};

function ModalConfirmation(props: ModalConfirmationProps) {
    const navigate = useNavigate();

    function backHome() {
        navigate(RouterPathResolver.pathEntryPoint.path);
    }
    return (
        <React.Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(()=>{return (<></>)})()} title={""} className={styles.modalCtaStyle} themeColor={props.themeColor}>
                <div className={`${styles.modal}`}>
                    {
                        props.isOkay ? <div> {translator.decode("modal.requestSend")}</div> : <div> {translator.decode("modal.requestFail")} </div>
                    }
                    <button className={`${styles.button}`} onClick={backHome}> {translator.decode("modal.backHome")} </button>
                </div>
            </MyModal>
        </React.Fragment>
    )
}

export default ModalConfirmation;
